import axios from '../localAxios';
import { copyWorkspaceQuizURL } from './workspacesURLs';

interface CopyWorkspaceQuizParams {
  workspaceId: string;
  workspaceQuizId: string;
  newName: string;
  parentId?: string;
}

export async function copyWorkspaceQuiz({
  newName,
  parentId,
  workspaceQuizId,
  workspaceId,
}: CopyWorkspaceQuizParams) {
  const url = copyWorkspaceQuizURL(workspaceId);
  const response = await axios.post<CopyWorkspaceQuizParams>(url.href, {
    name: newName,
    parent_id: parentId ?? null,
    workspace_quiz_id: workspaceQuizId,
  });
  return response.data;
}
